import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const UPDATE_COMPANY_QUERY = graphql(`
  mutation updateCompany(
    $companyID: ID!
    $settingID: ID!
    $input: UpdateCompanyInput!
    $settingInput: UpdateCompanySettings!
  ) {
    updateCompany(companyID: $companyID, input: $input) {
      id
      logo
      name
    }

    updateCompanySettings(id: $settingID, input: $settingInput) {
      id
      currency
    }
  }
`);

export function useUpdateCompanyAll() {
  return useMutation(UPDATE_COMPANY_QUERY, {});
}
